import { Controller } from "@hotwired/stimulus"
import StartToastifyInstance from "toastify-js";

export default class extends Controller {
  static targets = ["input", "list", "files"]

  connect() {
    this.files = []
  }

  openInput() {
    this.inputTarget.click()
  }

  add(event) {
    const file = event.target.files[0];
    if (!file) return

    this.files.push(file);
    this.displayFile(file);
    this.clearInput();
    this.addToInput(file);
  }

  displayFile(file) {
    const li = document.createElement("li");
    li.className = "flex w-full items-center rounded-md border border-gray-200 px-4 py-2.5 text-left text-sm transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2";
    li.textContent = file.name;
    this.listTarget.appendChild(li);
  }

  clearInput() {
    const newInput = this.inputTarget.cloneNode();
    this.inputTarget.value = "";
  }

  addToInput(file) {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    for(let i = 0; i < this.filesTarget.files.length; i++) {
      dataTransfer.items.add(this.filesTarget.files[i]);
    }

    this.filesTarget.files = dataTransfer.files;
  }

  validate(event) {
    if (this.filesTarget.files.length == 0) {
      event.preventDefault();
      StartToastifyInstance({
        text: "Selecione ao menos um arquivo.",
        duration: 3000,
        close: true,
        gravity: "bottom",
        position: "center",
        backgroundColor: "#ff0000",
        stopOnFocus: true,
      }).showToast();
      return;
    } 
  }
}